export enum TenantStatusEnum {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  BLOCKED = 'Blocked',
}
